import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { TunesSummary } from './TunesSummary';
import { GrantsRemainingCurrent } from './GrantsRemainingCurrent';

export class TunesSummaryResource extends FBaseService {
  public async getTunesSummary(fiId: string, cycleId: number, productId: number | null): Promise<TunesSummary[]> {
    let url: string = `/api/rcx/reporting/${fiId}/tunes-summary/${cycleId}`;
    if (productId) {
      url += `?productId=${productId}`;
    }

    const response: AxiosResponse = await this.apiClient.get(url);

    const results: TunesSummary[] = response.data.data;
    return results;
  }

  public async getGrantsRemainingCurrent(fiId: string): Promise<GrantsRemainingCurrent> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/tunes-summary-current/`);

    const results: GrantsRemainingCurrent = response.data.data;
    return results;
  }
}

export default TunesSummaryResource;
